import { Skeleton, TableCell, TableRow } from "@mui/material";
import styles from "../shop.module.css";

/**
 * Skeletons for the Shop order list while orders load. The page header, status cards and filters stay
 * usable; only the rows are replaced, in the same layout as the real ones so nothing jumps.
 */

// Desktop: placeholder table rows (9 columns, same order as the real table)
export const OrderRowsLoader = ({ rows = 8 }) => Array.from({ length: rows }).map((_, i) => (<TableRow key={i} aria-hidden="true">
  <TableCell><Skeleton variant="text" width={70} /></TableCell>
  <TableCell><Skeleton variant="text" width={120} /><Skeleton variant="text" width={90} height={14} /></TableCell>
  <TableCell><Skeleton variant="text" width={110} /></TableCell>
  <TableCell><Skeleton variant="text" width={85} /></TableCell>
  <TableCell><Skeleton variant="text" width={85} /></TableCell>
  <TableCell align="right"><Skeleton variant="text" width={24} style={{ marginLeft: "auto" }} /></TableCell>
  <TableCell align="right"><Skeleton variant="text" width={60} style={{ marginLeft: "auto" }} /></TableCell>
  <TableCell><Skeleton variant="rounded" width={52} height={24} style={{ borderRadius: 12 }} /><Skeleton variant="text" width={80} height={14} /></TableCell>
  <TableCell><Skeleton variant="rounded" width={96} height={24} style={{ borderRadius: 12 }} /></TableCell>
</TableRow>));

// Mobile: placeholder order cards
export const OrderCardsLoader = ({ rows = 5 }) => Array.from({ length: rows }).map((_, i) => (<div className={`${styles.Card}`} key={i} aria-hidden="true">
  <div className={`${styles.CardHead}`}>
    <div style={{ flex: 1 }}>
      <Skeleton variant="text" width="40%" />
      <Skeleton variant="text" width="60%" height={14} />
    </div>
    <Skeleton variant="rounded" width={90} height={24} style={{ borderRadius: 12 }} />
  </div>
  {[0, 1, 2].map((r) => (<div className={`${styles.CardRow}`} key={r}>
    <Skeleton variant="text" width={60} />
    <Skeleton variant="text" width={80} />
  </div>))}
</div>));
